import type { ReactElement } from "react"
import React from "react"
import _t from "@core/i18n"
import type { MarkdownToJSX } from "markdown-to-jsx"
import Markdown from "markdown-to-jsx"
import PlainLinkAtm from "@onestore/hel/dist/components/atoms/PlainLinkAtm"
import AlignContentOrg from "@onestore/hel/dist/components/organisms/AlignContentOrg"
import FlexContainerOrg from "@onestore/hel/dist/components/organisms/FlexContainerOrg"
import FlexItemOrg from "@onestore/hel/dist/components/organisms/FlexItemOrg"
import PushOrg from "@onestore/hel/dist/components/organisms/PushOrg"
import SurfaceOrg from "@onestore/hel/dist/components/organisms/SurfaceOrg"
import useBreakpoint from "@onestore/hel/dist/hooks/useBreakpoint"
import Media from "@gatsby-plugin-generic-page/components/Media"
import getBaseMarkdownOverrides from "@gatsby-plugin-generic-page/helpers/getBaseMarkdownOverrides"
import type { EmbeddedAssetSquidexMetadata } from "~/fragments/image"

const markdownOverrides: MarkdownToJSX.Overrides = {
  ...getBaseMarkdownOverrides({
    typography: "xsmall1",
    pushSpace: 1,
    boldTypography: "xsmall2",
  }),
  a: {
    component: PlainLinkAtm,
    props: {
      color: "secondary",
      typography: "big2",
      type: "underline",
      title: _t("marketplace.checkProduct"),
    },
  },
}

interface SmallBannerBoxProps {
  text: string
  image: EmbeddedAssetSquidexMetadata[]
}

export default function SmallBannerBox({
  text,
  image,
}: SmallBannerBoxProps): ReactElement<SmallBannerBoxProps> {
  const isMediumScreenOnly = useBreakpoint("medium", "large")

  const markdownElement = (
    <Markdown
      options={{
        forceInline: false,
        overrides: markdownOverrides,
      }}
    >
      {text}
    </Markdown>
  )

  const contentJsx = isMediumScreenOnly ? (
    <AlignContentOrg horizontalAlign="center">
      {markdownElement}
    </AlignContentOrg>
  ) : (
    <FlexContainerOrg>
      <div>{markdownElement}</div>

      <FlexItemOrg flexShrink={0}>
        <PushOrg leftSpace={2} hasNoReset>
          <Media media={image} />
        </PushOrg>
      </FlexItemOrg>
    </FlexContainerOrg>
  )

  return (
    <SurfaceOrg spacingSpace={{ vertical: 2, horizontal: 2 }}>
      {contentJsx}
    </SurfaceOrg>
  )
}
